"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTechnicianApiClient = void 0;
const shared_logger_1 = require("@aladin/shared-logger");
const shared_common_sdk_1 = require("@aladin/shared-common-sdk");
function createTechnicianApiClient(options) {
    const logger = options.logger ?? shared_logger_1.NOOP_LOGGER;
    const client = (0, shared_common_sdk_1.createAxiosClient)(options.technicianApiHost, {
        accessTokenSource: options.accessTokenSource,
    });
    async function fetchTechnicianByPartnerIdAndTechnicianId(partnerId, technicianId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/technicians/${technicianId}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function fetchTechnicianStores(request) {
        try {
            const response = await client.get(`/v1/partners/${request.partnerId}/technicians/${request.technicianId}/stores`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    return {
        fetchTechnicianStores,
        fetchTechnicianByPartnerIdAndTechnicianId
    };
}
exports.createTechnicianApiClient = createTechnicianApiClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVjaG5pY2lhbnMuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RlY2huaWNpYW5zL3RlY2huaWNpYW5zLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx5REFBMkQ7QUFDM0QsaUVBQTBFO0FBNkIxRSxTQUFnQix5QkFBeUIsQ0FBQyxPQUFtQztJQUMzRSxNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsTUFBTSxJQUFJLDJCQUFXLENBQUE7SUFFNUMsTUFBTSxNQUFNLEdBQUcsSUFBQSxxQ0FBaUIsRUFBQyxPQUFPLENBQUMsaUJBQWlCLEVBQUU7UUFDMUQsaUJBQWlCLEVBQUUsT0FBTyxDQUFDLGlCQUFpQjtLQUM3QyxDQUFDLENBQUE7SUFFRixLQUFLLFVBQVUseUNBQXlDLENBQ3RELFNBQWlCLEVBQ2pCLFlBQW9CO1FBRXBCLElBQUk7WUFDRixNQUFNLFFBQVEsR0FBRyxNQUFNLE1BQU0sQ0FBQyxHQUFHLENBQWdCLGdCQUFnQixTQUFTLGdCQUFnQixZQUFZLEVBQUUsQ0FBQyxDQUFBO1lBQ3pHLE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQTtTQUNyQjtRQUFDLE9BQU8sR0FBRyxFQUFFO1lBQ1osSUFBSSxHQUFHLFlBQVksS0FBSztnQkFBRSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUE7WUFDdkQsSUFBQSwrQkFBVyxFQUFDLEdBQUcsQ0FBQyxDQUFBO1NBQ2pCO0lBQ0gsQ0FBQztJQUVELEtBQUssVUFBVSxxQkFBcUIsQ0FBQyxPQUFvRDtRQUN2RixJQUFJO1lBQ0YsTUFBTSxRQUFRLEdBQUcsTUFBTSxNQUFNLENBQUMsR0FBRyxDQUMvQixnQkFBZ0IsT0FBTyxDQUFDLFNBQVMsZ0JBQWdCLE9BQU8sQ0FBQyxZQUFZLFNBQVMsQ0FDL0UsQ0FBQTtZQUNELE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQTtTQUNyQjtRQUFDLE9BQU8sR0FBRyxFQUFFO1lBQ1osSUFBSSxHQUFHLFlBQVksS0FBSztnQkFBRSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUE7WUFDdkQsSUFBQSwrQkFBVyxFQUFDLEdBQUcsQ0FBQyxDQUFBO1NBQ2pCO0lBQ0gsQ0FBQztJQUlELE9BQU87UUFDTCxxQkFBcUI7UUFDckIseUNBQXlDO0tBQzFDLENBQUE7QUFDSCxDQUFDO0FBdENELDhEQXNDQyJ9